import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { UserType } from '../../types';
import Util from '../../util';
import { useApi } from '../../hooks/useApi';
import Spinner from '../../components/Spinner';

type ConfirmModalProps = {
  userType: UserType;
  hideModal: () => void;
  initial: string;
  email: string;
  password: string;
}

const ConfirmModal = (props: ConfirmModalProps) => {
  const [ userType, setUserType ] = useState(props.userType);
  const hideModal = props.hideModal;
  const initial = props.initial;
  const email = props.email;
  const password = props.password;

  const navigate = useNavigate();
  const { post, loading } = useApi();

  const signup = () => {
    post({
      endpoint: `api/v1/signup`,
      skipAuth: true,
      body: {
        name: initial,
        email: email,
        password: password,
        password_confirmation: password,
        user_type: userType
      },
      onSuccess: (res) => {
        navigate('/register_temp?email=' + email)
      },
      onError: (err) => {
        toast.error("登録に失敗しました。時間をおいて再度お試しください。");
      },
    });
  }

  return (
    <section className="modalarea">
      <div className="modalbg" onClick={ hideModal }></div>
      <div className="modalwrapper">
        <div>
          { userType === UserType.Donee ?
            <h2 className="sec_title">ドナーを探す</h2> :
            <h2 className="sec_title blue">ドナーになる</h2>
          }
          <dl
            className={
              userType === UserType.Donee ? "graf_list pink" : "graf_list blue"
            }
          >
            <dt>イニシャル</dt>
            <dd>{ Util.toDispInitial(initial) }</dd>
            <dt>メールアドレス</dt>
            <dd>{ email }</dd>
          </dl>
          { userType === UserType.Donee ?
            <p>私は<span className="txt_pink">女性</span>で精子提供をする<span className="txt_blue">男性ドナー</span>を探しています。</p> :
            <p>私は<span className="txt_blue">男性</span>で<span className="txt_blue">精子提供ドナー</span>として登録します。</p>
          }
          <ul className="btnarea">
            { userType === UserType.Donee ?
              <>
                <li>
                  <button
                    className="w_pinkbtn"
                    onClick={ () => signup() }
                    disabled={ loading }
                  >
                    { loading ? <Spinner size="small" color="pink" /> : 'はい（仮登録完了）' }
                  </button>
                </li>
                <li>
                  <button
                    className="w_bluebtn smallbtn"
                    onClick={ () => setUserType(UserType.Donor) }
                    disabled={ loading }
                  >
                    いいえ（男性の方はこちら）
                  </button>
                </li>
              </> :
              <>
                <li>
                  <button
                    className="w_bluebtn"
                    onClick={ () => signup() }
                    disabled={ loading }
                  >
                    { loading ? <Spinner size="small" /> : 'はい（仮登録完了）' }
                  </button>
                </li>
                <li>
                  <button
                    className="w_pinkbtn smallbtn"
                    onClick={ () => setUserType(UserType.Donee) }
                    disabled={ loading }
                  >
                    いいえ（女性の方はこちら）
                  </button>
                </li>
              </>
            }
          </ul>
          <div className="closemodal" onClick={ hideModal }>×</div>
        </div>
      </div>
    </section>
  );
}

export default ConfirmModal;
